import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import RichTextEditor from "../../components/forms/RichTextEditor";

const AddProductTypeI: React.FC = () => {
  const navigate = useNavigate();
  const id = useMemo(() => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      // expecting .../completed-projects/detail/:id/products/type1/add
      const idx = parts.indexOf("detail");
      return idx >= 0 && parts[idx + 1] ? parts[idx + 1] : "";
    } catch {
      return "";
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    unit: "",
    spec: "",
    qty: "",
    content: "",
  });

  const handleChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    console.log("Save product type I:", { projectId: id, ...formData });
    window.history.back();
  };

  return (
    <PageShell title="Thêm sản phẩm dạng I">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm sản phẩm dạng I
          </h1>
        </div>

        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="p-6 space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tên sản phẩm <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên sản phẩm..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Đơn vị tính <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.unit}
                  onChange={(e) => handleChange("unit", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Ví dụ: Cái, Bộ..."
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Thông số
                </label>
                <input
                  type="text"
                  value={formData.spec}
                  onChange={(e) => handleChange("spec", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập thông số..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Số lượng
                </label>
                <input
                  type="number"
                  value={formData.qty}
                  onChange={(e) => handleChange("qty", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập số lượng..."
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nội dung - Thông số chi tiết sản phẩm
              </label>
              <RichTextEditor
                value={formData.content}
                onChange={(v: string) => handleChange("content", v)}
                placeholder="Mô tả chi tiết sản phẩm..."
                height="large"
              />
            </div>

            <div className="flex justify-end gap-2 pt-2">
              <button
                onClick={() => window.history.back()}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
              >
                Hủy
              </button>
              <button
                onClick={handleSave}
                className="bg-[#337ab7] hover:bg-[#2e6da4] text-white px-4 py-2 rounded text-sm font-medium"
              >
                Lưu
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default AddProductTypeI;
